import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { CallIcon } from "../../Assets/svgs/CallIcon";
import EndCallIcon from "../../Assets/svgs/EndCallIcon";
import MuteIcon from "../../Assets/svgs/MuteIcon";
import SolidTrashIcon from "../../Assets/svgs/SolidTrashIcon";
import UnMuteIcon from "../../Assets/svgs/UnMuteIcon";
import {
  ALL_ASSISTANT_LLM_PROVIDER,
  ALL_FORM_FIELDS,
  ALL_TRANSCRIBER_PROVIDERS,
  ALL_VOICE_PROVIDERS,
  INITIAL_ADD_ASSISTANT_DATA as INITIAL_FORMDATA,
  WIDGET_POSITION,
} from "../../Common/Constants";
import { deleteById, getFile } from "../../Common/indexDb";
import { Loader } from "../../Common/Loader";
import {
  emailValidation,
  getPhoneNumberLimits,
  handlePhoneNoChange,
  phoneNumberValidation,
} from "../../Common/Validations";
import { ConfirmModel } from "../../Model/ConfirmModel";
import EditAssistantModal from "../../Model/EditAssistantModal";
import { ErrorModel } from "../../Model/ErrorModel";
import { SuccessModel } from "../../Model/SuccessModel";
import { CreateAssistant } from "../../Redux/Slice/Assistant/AddAssistantSlice";
import { DeleteAssistant } from "../../Redux/Slice/Assistant/DeleteAssistantSlice";
import { getAssistantById } from "../../Redux/Slice/Assistant/GetASsistantById";
import { UpdateAssistant } from "../../Redux/Slice/Assistant/UpdateAssistantSLice";
import { setUnsavedChanges } from "../../Redux/Slice/Common/SelectedTabSlice";
import { getAssistantDocumentsList } from "../../Redux/Slice/Documents/AssistantDocumentListSlice";
import AdvancedTab from "./AddAssistantTabs/AdvancedTab";
import EmailTab from "./AddAssistantTabs/EmailTab";
import FormTab from "./AddAssistantTabs/FormTab";
import SetUpTab from "./AddAssistantTabs/SetUpTab";
import VoiceTab from "./AddAssistantTabs/VoiceTab";
import WebsiteWidgetTab from "./AddAssistantTabs/WebsiteWidgetTab";
import { AssistantsListSidebar } from "./AssistantsListSidebar";
import useCallFrontDesk from "./Hook/useCallFrontDesk";
import EditBlueIcon from "../../Assets/svgs/EditBlueIcon";
import { DefaultChatBot } from "../../Assets/svgs/DefaultChatBot";
import {
  copyToClipboard,
  getCountryCodeByFullPhone,
  getUserData,
} from "../../Common/utils";
import ShareIcon from "../../Assets/svgs/ShareIcon";
import { shareAssistantForm } from "../../Redux/Slice/Form/ShareAssistantFormSlice";
import PhoneNumberTab from "./AddAssistantTabs/PhoneNumberTab";
import { getPhoneNumbers } from "../../Redux/Slice/PhoneNumbers/GetPhoneNumberListSlice";
import { addAssistantBackground } from "../../Redux/Slice/Assistant/AddAssistantBackgroundSlice";
import { getKnowledgeBaseList } from "../../Redux/Slice/KnowledgeBase/GetKnowledgeBaseListSlice";
import { getAssistantList } from "../../Redux/Slice/Assistant/AssistantsListSlice";
import CopyIcon from "../../Assets/svgs/CopyIcon";
import CopyBox from "../../Common/CopyBox";
import ShareLinkModal from "../../Common/ShareLinkModal";
import { getAssistantsCount } from "../../Redux/Slice/Assistant/GetAssistantCountSlice";
import useCreateAssistant from "./../../Hooks/useCreateAssistant";
import BuyAdditionalAssistantModal from "../../Model/BuyAdditionalAssistantModal";

export const AddAssistant = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const divRef = useRef(null);
  const customerId = location.pathname.includes("/add-assistant/")
    ? location.pathname.split("/")[2]
    : undefined;
  const [tabs, selectedTab] = useState(1);
  const [editAssistantVisible, setEditAssistantVisible] = useState(false);
  const [selectedBot, setSelectedBot] = useState({ name: "", avatar: "" });
  const [selectedBackground, setSelectedBackground] = useState(null);
  const [formData, setFormData] = useState(INITIAL_FORMDATA);
  const [formError, setFormError] = useState({
    subjectError: "",
    descriptionError: "",
    emailError: "",
  });
  const [errorModel, setErrorModel] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successModel, setSuccessModel] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [hasChanged, setHasChanged] = useState(false);
  const [hasChangedModel, setHasChangedModel] = useState(false);
  const [confirmModel, setCOnfirmModel] = useState(false);
  const [selectedRow, setselectedRow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [shareFormLinkModal, setShareFormLinkModal] = useState({
    visible: false,
    url: "",
  });
  const {
    onClickCreateAssistant,
    buyAdditionalAssistantModal,
    handleCloseBuyAdditionalAssistant,
  } = useCreateAssistant(customerId, setIsLoading);
  const [selectedKnowledgeBaseDocument, setSelectedKnowledgeBaseDocument] =
    useState("");
  const assistantDetails = useSelector(
    (state) => state.assistantDetails.assistantDetails
  );
  const assistantCountData = useSelector(
    (s) => s?.assistantCount?.assistantCountData
  );
  const { userPlanDetailsData, userPlanFeatures } = useSelector(
    (s) => s?.userPlanDetails
  );
  const currentUserData = useSelector((s) => s?.currentUser?.userData);
  const userData = currentUserData ? currentUserData : getUserData();
  const isMetaAssistant = location.pathname == "/add-meta-assistant";

  const showErrorMessage = (message, callback) => {
    setErrorMessage(message ?? "");
    setErrorModel(true);
    setTimeout(() => {
      setErrorModel(false);
      setErrorMessage("");
      if (typeof callback === "function") {
        callback();
      }
    }, 1500);
  };

  const showSuccessMessage = (message, callback) => {
    setSuccessMessage(message ?? "");
    setSuccessModel(true);
    setTimeout(() => {
      setSuccessModel(false);
      setSuccessMessage("");
      if (typeof callback === "function") {
        callback();
      }
    }, 1500);
  };

  const { isCallActive, isMuted, startCall, toggleMute, endCall } =
    useCallFrontDesk({
      vapiAssistanceId: selectedBot?.id,
      setIsLoading,
      showSuccessMessage,
    });
  // const botName = location?.state?.selectedBot
  //   ? location?.state?.selectedBot
  //   : "";

  const getDocumentsList = async () => {
    setIsLoading(true);
    await dispatch(
      getKnowledgeBaseList({
        keyword: "",
        type: "dropdown",
        customerId,
      })
    );
    setIsLoading(false);
  };

  useEffect(() => {
    getDocumentsList();
    dispatch(getPhoneNumbers({ customerId }));
    if (location?.state?.from === "edit") {
      getBotdetails(location?.state?.selectedBotId);
    } else {
      setSelectedBot({
        name: location.state?.name,
        avatar: location.state?.avatar,
      });
      selectedTab(1);
      if (location.state?.details) {
        setData(location.state?.details);
      } else {
        setData({ name: location.state?.name });
      }
    }
  }, [location?.state]);

  const getBotdetails = async (id) => {
    setIsLoading(true);
    await dispatch(getAssistantById(id));
    setIsLoading(false);
  };

  const onDelete = async () => {
    setCOnfirmModel(false);
    setIsLoading(true);
    const result = await dispatch(DeleteAssistant(selectedBot?.id));
    setIsLoading(false);
    if (
      DeleteAssistant.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setSuccessMessage("Assistant Deleted Successfully!");
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
        if (customerId) {
          navigate(`/assistants/${customerId}`, {
            state: {
              planType: location?.state?.planType,
              customerName: location?.state?.customerName,
            },
          });
        } else {
          navigate("/assistants");
        }
      }, 1500);
    } else {
      //TODO: error popup here

      setErrorMessage(result?.payload?.error?.message);
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    }
  };

  const onDeleteClicked = (row) => {
    setselectedRow(row);
    setCOnfirmModel(true);
  };

  useEffect(() => {
    if (location.state?.from === "edit" && assistantDetails) {
      setSelectedBot(assistantDetails.data);
      setData(assistantDetails.data);
      // changeSelection(assistantDetails.data);s
    }
  }, [assistantDetails]);

  const hasFormError = useMemo(() => {
    return Object.values(formError).some((error) => {
      return typeof error === "string" && error?.length > 1;
    });
  }, [formError]);

  const handleChangeSetupStep = (e) => {
    let { name, value, type, checked } = e.target;
    setHasChanged(true);
    dispatch(setUnsavedChanges(true));
    setFormData((prevData) => ({
      ...prevData,
      setup: {
        ...prevData?.setup,
        [name]: type == "checkbox" ? checked : value,
      },
      advanced: {
        ...prevData?.advanced,
        callSettings: {
          ...prevData.advanced?.callSettings,
          audioRecording:
            checked && name == "sendRecording"
              ? true
              : prevData.advanced.callSettings.audioRecording,
        },
      },
    }));
    if (
      (name == "sendSummary" ||
        name == "sendSummaryToContact" ||
        name == "pdfSummary" ||
        name == "sendTranscript" ||
        name == "sendRecording") &&
      checked
    ) {
      setTimeout(() => {
        divRef?.current &&
          divRef?.current?.scrollIntoView({
            top: 0,
            behavior: "smooth",
            block: "end",
          });
      }, 500);
    }
  };

  const handleChangeEmailStep = (e) => {
    let { name, value } = e.target;
    if (name === "subject") {
      let capitalized = value.charAt(0).toString().toUpperCase();
      value = capitalized + value.substring(1);
      // save position of cursor
      const savedPos = e.target.selectionStart;
      const isValid = !(value?.length < 3);
      if (isValid || value.trim() === "") {
        setFormError({ ...formError, subjectError: "" });
      } else {
        setFormError({
          ...formError,
          subjectError: "Please enter valid subject",
        });
      }
      setTimeout(() => {
        // restore cursor position
        e.target.setSelectionRange(savedPos, savedPos);
      }, 0);
    } else if (name === "description") {
      let capitalized = value.charAt(0).toString().toUpperCase();
      value = capitalized + value.substring(1);
      const isValid = !(value?.length < 3);
      if (isValid || value.trim() === "") {
        setFormError({ ...formError, descriptionError: "" });
      } else {
        setFormError({
          ...formError,
          descriptionError: "Please enter valid message",
        });
      }
    }

    setFormData((prevData) => ({
      ...prevData,
      email: {
        ...formData.email,
        [name]: value,
      },
    }));
    setHasChanged(true);
    dispatch(setUnsavedChanges(true));
  };

  const handleChangeWebsiteWidget = (e) => {
    let { name, value } = e.target;
    dispatch(setUnsavedChanges(true));
    setHasChanged(true);
    if (name == "forwardingCountryCallingCode") {
      let formatted = formData.widget.forwardingPhoneNumber;
      setFormData((prev) => ({
        ...prev,
        widget: {
          ...prev.widget,
          [name]: value,
          forwardingPhoneNumber: formatted,
        },
      }));
      const minDigits = getPhoneNumberLimits(value)?.min ?? 10;
      const rawDigits = formData?.widget?.forwardingPhoneNumber.replace(
        /\D/g,
        ""
      );
      const isValid = phoneNumberValidation(rawDigits, value);
      setFormError({
        ...formError,
        widgetForwardingPhoneError:
          isValid || value === ""
            ? ""
            : rawDigits.length < minDigits
            ? `Phone number must be at least ${minDigits} digits long.`
            : "Please enter a valid phone number",
      });
    } else if (name == "forwardingPhoneNumber") {
      handlePhoneNoChange(
        e,
        formData.widget.forwardingCountryCallingCode,
        () =>
          setFormData((prev) => ({
            ...prev,
            widget: {
              ...prev.widget,
              [name]: value,
            },
          })),
        (newError) =>
          setFormError({ ...formError, widgetForwardingPhoneError: newError }),
        (isChanged) => {
          dispatch(setUnsavedChanges(true));
          setHasChanged(isChanged);
        },
        false
      );
    } else if (
      name == "widgetColorOpacity" ||
      name == "headerBgColorOpacity" ||
      name == "headerTextColorOpacity"
    ) {
      setFormData((prev) => ({
        ...prev,
        widget: {
          ...prev.widget,
          [name]: isNaN(Number(value))
            ? 0
            : Number(value) > 100 || Number(value) < 0
            ? prev?.widget[name]
            : Number(value),
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        widget: {
          ...prev.widget,
          [name]: value,
        },
      }));
    }
  };

  const handleChangeVoiceStep = (e) => {
    let { name, value, type, checked } = e.target;
    setHasChanged(true);
    dispatch(setUnsavedChanges(true));

    if (name == "assistantProvider") {
      const allModelList =
        ALL_ASSISTANT_LLM_PROVIDER.find((i) => i?.value === value)?.models ||
        [];

      setFormData((prevData) => ({
        ...prevData,
        voice: {
          ...prevData?.voice,
          assistantModel: allModelList?.length ? allModelList[0]?.value : "",
          provider: value == "openai" ? "openai" : prevData?.voice?.provider,
          voice: value == "openai" ? "alloy" : prevData?.voice?.voice,
          [name]: type == "checkbox" ? checked : value,
        },
      }));
    } else if (name == "transcriberProvider") {
      const currentTranscriberData = ALL_TRANSCRIBER_PROVIDERS.find(
        (i) => i?.value === value
      );

      setFormData((prevData) => ({
        ...prevData,
        voice: {
          ...prevData?.voice,
          transcriberModel: currentTranscriberData?.models[0]?.value,
          language:
            Array.isArray(currentTranscriberData?.models[0]?.languages) &&
            currentTranscriberData?.models[0]?.languages?.length
              ? currentTranscriberData?.models[0]?.languages[0]
              : currentTranscriberData?.languages[0],
          [name]: type == "checkbox" ? checked : value,
        },
      }));
    } else if (name == "transcriberModel") {
      const currentTranscriberData = ALL_TRANSCRIBER_PROVIDERS.find(
        (i) => i?.value === formData.voice.transcriberProvider
      );
      const currentModelData = currentTranscriberData
        ? currentTranscriberData?.models?.find((model) => model.value === value)
        : null;

      setFormData((prevData) => ({
        ...prevData,
        voice: {
          ...prevData?.voice,
          language:
            currentModelData &&
            Array.isArray(currentModelData?.languages) &&
            currentModelData?.languages?.length
              ? currentModelData?.languages[0]
              : prevData?.voice?.language,
          [name]: type == "checkbox" ? checked : value,
        },
      }));
    } else if (name == "provider") {
      const currentVoiceProviderData = ALL_VOICE_PROVIDERS.find(
        (i) => i?.value === value
      );

      setFormData((prevData) => ({
        ...prevData,
        voice: {
          ...prevData?.voice,
          voice: currentVoiceProviderData?.voiceId[0]?.value,
          isCustomVoiceId: false,
          [name]: type == "checkbox" ? checked : value,
        },
      }));
    } else if (name == "isCustomVoiceId") {
      const currentVoiceProviderData = ALL_VOICE_PROVIDERS.find(
        (i) => i?.value === formData.voice.provider
      );
      setFormData((prevData) => ({
        ...prevData,
        voice: {
          ...prevData?.voice,
          voice: checked
            ? prevData.voice.voice
            : currentVoiceProviderData?.voiceId[0]?.value,
          [name]: checked,
        },
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        voice: {
          ...prevData?.voice,
          [name]: type == "checkbox" ? checked : value,
        },
      }));
    }
  };

  const setData = (newBot) => {
    setSelectedBot(newBot);
    setSelectedBackground(null);
    try {
      setSelectedKnowledgeBaseDocument(newBot?.model?.knowledgeBaseId ?? "");

      const isCreateNewAssistant = location.state?.from != "edit";
      const advancedCountryCode = newBot?.forwardingPhoneNumber
        ? getCountryCodeByFullPhone(newBot?.forwardingPhoneNumber)
        : INITIAL_FORMDATA.advanced.functions.countryCallingCode;

      const fallBackCountryCode = newBot?.phoneNumber?.fallbackDestination
        ?.number
        ? getCountryCodeByFullPhone(
            newBot?.phoneNumber?.fallbackDestination?.number
          )
        : INITIAL_FORMDATA.phoneNumber.fallbackDestinationCountryCode;

      const currentVoiceProvider = newBot?.voice?.provider
        ? newBot?.voice?.provider
        : INITIAL_FORMDATA.voice.provider;
      const currentVoiceProviderVoice = newBot?.voice?.voiceId
        ? newBot?.voice?.voiceId
        : INITIAL_FORMDATA.voice.voice;
      const currentVoiceProviderVoices = ALL_VOICE_PROVIDERS.find(
        (i) => i?.value === currentVoiceProvider
      );
      const isCustomVoiceId = currentVoiceProviderVoices
        ? !currentVoiceProviderVoices?.voiceId?.some(
            (voice) => voice.value == currentVoiceProviderVoice
          )
        : true;

      setFormData({
        ...INITIAL_FORMDATA,
        setup: {
          ...INITIAL_FORMDATA.setup,
          assistantType:
            newBot?.assistantType || INITIAL_FORMDATA.setup.assistantType,
          firstMessage: newBot?.firstMessage || "",
          systemPrompt:
            Array.isArray(newBot?.model?.messages) &&
            newBot?.model?.messages?.length &&
            newBot?.model?.messages[0].content
              ? newBot?.model?.messages[0].content
              : "",
          emailAddress: Array.isArray(newBot?.emailAddress)
            ? newBot?.emailAddress
            : isCreateNewAssistant
            ? [userData?.email]
            : [],
          sendSummary: newBot?.sendSummary
            ? newBot?.sendSummary
            : isCreateNewAssistant
            ? INITIAL_FORMDATA.setup.sendSummary
            : false,
          sendSummaryToContact: newBot?.sendSummaryToContact
            ? newBot?.sendSummaryToContact
            : isCreateNewAssistant
            ? INITIAL_FORMDATA.setup.sendSummaryToContact
            : false,
          pdfSummary: newBot?.pdfSummary
            ? newBot?.pdfSummary
            : isCreateNewAssistant
            ? INITIAL_FORMDATA.setup.pdfSummary
            : false,
          sendTranscript: newBot?.sendTranscript
            ? newBot?.sendTranscript
            : isCreateNewAssistant
            ? INITIAL_FORMDATA.setup.sendTranscript
            : false,
          sendRecording: newBot?.sendRecording
            ? newBot?.sendRecording
            : isCreateNewAssistant
            ? INITIAL_FORMDATA.setup.sendRecording
            : false,
          backgroundImage: newBot?.webScreen || "",
          summaryInstructions: newBot?.analysisPlan?.summaryPrompt
            ? newBot?.analysisPlan?.summaryPrompt
            : isCreateNewAssistant
            ? INITIAL_FORMDATA.setup.summaryInstructions
            : "",
        },
        form: {
          ...INITIAL_FORMDATA.form,
          fields:
            Array.isArray(newBot?.form?.fields) && newBot?.form?.fields?.length
              ? newBot?.form?.fields
                  ?.map((field) => ({
                    ...field,
                    label: field?.name ?? field?.label,
                  }))
                  .sort((a, b) => a?.order - b?.order)
              : INITIAL_FORMDATA.form.fields,
          instructions: newBot?.form?.instructions
            ? newBot?.form?.instructions
            : isCreateNewAssistant
            ? INITIAL_FORMDATA.form.instructions
            : "",
          formActions: Array.isArray(newBot?.form?.submitAction)
            ? newBot?.form?.submitAction
            : isCreateNewAssistant
            ? INITIAL_FORMDATA.form.formActions
            : [],
        },
        email: {
          ...INITIAL_FORMDATA.email,
          subject: newBot?.email?.subject || "",
          description: newBot?.email?.description || "",
        },
        widget: {
          ...INITIAL_FORMDATA.widget,
          ...newBot?.widgetConfig,
          websites: Array.isArray(newBot?.widgetConfig?.websites)
            ? newBot?.widgetConfig.websites
            : INITIAL_FORMDATA.widget.websites,
          emailNotification: Array.isArray(
            newBot?.widgetConfig?.emailNotification
          )
            ? newBot?.widgetConfig.emailNotification
            : INITIAL_FORMDATA.widget.emailNotification,
          desktopWidgetIconPosition: newBot?.widgetConfig
            ?.desktopWidgetIconPosition
            ? newBot?.widgetConfig.desktopWidgetIconPosition
            : INITIAL_FORMDATA.widget.desktopWidgetIconPosition,
          mobileWidgetIconPosition: newBot?.widgetConfig
            ?.mobileWidgetIconPosition
            ? newBot?.widgetConfig?.mobileWidgetIconPosition
            : INITIAL_FORMDATA.widget.mobileWidgetIconPosition,
          forwardingPhoneNumber: newBot?.widgetConfig?.forwardingPhoneNumber
            ? newBot?.widgetConfig?.forwardingPhoneNumber
            : INITIAL_FORMDATA.advanced.functions.phoneNumber,
        },
        voice: {
          ...INITIAL_FORMDATA.voice,
          assistantProvider: newBot?.model?.provider
            ? newBot?.model?.provider
            : INITIAL_FORMDATA.voice.assistantProvider,
          assistantModel: newBot?.model?.model
            ? newBot?.model?.model
            : INITIAL_FORMDATA.voice.assistantModel,
          transcriberProvider: newBot?.transcriber?.provider
            ? newBot?.transcriber?.provider
            : INITIAL_FORMDATA.voice.transcriberProvider,
          transcriberModel: newBot?.transcriber?.model
            ? newBot?.transcriber?.model
            : INITIAL_FORMDATA.voice.transcriberModel,
          provider: newBot?.voice?.provider
            ? newBot?.voice?.provider
            : INITIAL_FORMDATA.voice.provider,
          voice: newBot?.voice?.voiceId || INITIAL_FORMDATA.voice.voice,
          isCustomVoiceId:
            isCustomVoiceId || INITIAL_FORMDATA.voice.isCustomVoiceId,
          backgroundSound: newBot?.backgroundSound
            ? newBot?.backgroundSound
            : isCreateNewAssistant
            ? INITIAL_FORMDATA.voice.backgroundSound
            : "",
          language: newBot?.transcriber?.language
            ? newBot?.transcriber?.language
            : INITIAL_FORMDATA.voice.language,
          speed: newBot?.voice?.speed || INITIAL_FORMDATA.voice.speed,
          endCallPhrases:
            Array.isArray(newBot?.endCallPhrases) &&
            newBot?.endCallPhrases?.length
              ? newBot?.endCallPhrases[0]
              : isCreateNewAssistant
              ? INITIAL_FORMDATA.voice.endCallPhrases
              : "",
          voiceMailMessage: newBot?.voicemailMessage
            ? newBot?.voicemailMessage
            : isCreateNewAssistant
            ? INITIAL_FORMDATA.voice.voiceMailMessage
            : "",
          endCallMessage: newBot?.endCallMessage
            ? newBot?.endCallMessage
            : isCreateNewAssistant
            ? INITIAL_FORMDATA.voice.endCallMessage
            : "",
          emotionRecognitionEnabled: newBot?.model?.emotionRecognitionEnabled
            ? newBot?.model?.emotionRecognitionEnabled
            : isCreateNewAssistant
            ? INITIAL_FORMDATA.voice.emotionRecognitionEnabled
            : false,
        },
        advanced: {
          ...INITIAL_FORMDATA.advanced,
          callSettings: {
            backchanneling:
              newBot?.backchannelingEnabled ||
              INITIAL_FORMDATA.advanced.callSettings.backchanneling,
            backgroundDenoising: newBot?.backgroundDenoisingEnabled
              ? newBot?.backgroundDenoisingEnabled
              : isCreateNewAssistant
              ? INITIAL_FORMDATA.advanced.callSettings.backgroundDenoising
              : false,
            filterInjection:
              newBot?.voice?.fillerInjectionEnabled ||
              INITIAL_FORMDATA.advanced.callSettings.filterInjection,
            stability:
              newBot?.stability ||
              INITIAL_FORMDATA.advanced.callSettings.stability,
            claritySimilarity:
              newBot?.claritySimilarity ||
              INITIAL_FORMDATA.advanced.callSettings.claritySimilarity,
            styleExaggeration:
              newBot?.styleExaggeration ||
              INITIAL_FORMDATA.advanced.callSettings.styleExaggeration,
            optimizeStreamingLatency:
              newBot?.optimizeStreamingLatency ||
              INITIAL_FORMDATA.advanced.callSettings.optimizeStreamingLatency,
            hipaaCompliance:
              newBot?.hipaaEnabled ||
              INITIAL_FORMDATA.advanced.callSettings.hipaaCompliance,
            audioRecording:
              newBot?.recordingEnabled ||
              INITIAL_FORMDATA.advanced.callSettings.audioRecording,
            videoRecording:
              newBot?.artifactPlan?.videoRecordingEnabled ||
              INITIAL_FORMDATA.advanced.callSettings.videoRecording,
            idleMessage: newBot?.messagePlan?.idleMessages
              ? newBot?.messagePlan?.idleMessages
              : isCreateNewAssistant
              ? INITIAL_FORMDATA.advanced.callSettings.idleMessage
              : "",
            maxIdleMessage: newBot?.messagePlan?.idleMessageMaxSpokenCount
              ? newBot?.messagePlan?.idleMessageMaxSpokenCount
              : isCreateNewAssistant
              ? INITIAL_FORMDATA.advanced.callSettings.maxIdleMessage
              : 0,
            idleTimeout: newBot?.messagePlan?.idleTimeoutSeconds
              ? newBot?.messagePlan?.idleTimeoutSeconds
              : isCreateNewAssistant
              ? INITIAL_FORMDATA.advanced.callSettings.idleTimeout
              : 0,
            voiceMailMessage: newBot?.voicemailMessage
              ? newBot?.voicemailMessage
              : isCreateNewAssistant
              ? INITIAL_FORMDATA.advanced.callSettings.voiceMailMessage
              : "",
            endMailMessage:
              newBot?.endCallMessage ||
              INITIAL_FORMDATA.advanced.callSettings.endMailMessage,
          },
          startSpeakingSettings: {
            waitSeconds: newBot?.startSpeakingPlan?.waitSeconds
              ? newBot?.startSpeakingPlan?.waitSeconds
              : isCreateNewAssistant
              ? INITIAL_FORMDATA.advanced.startSpeakingSettings.waitSeconds
              : 0,
            onPunctuationSeconds: newBot?.startSpeakingPlan
              ?.transcriptionEndpointingPlan?.onPunctuationSeconds
              ? newBot?.startSpeakingPlan?.transcriptionEndpointingPlan
                  ?.onPunctuationSeconds
              : isCreateNewAssistant
              ? INITIAL_FORMDATA.advanced.startSpeakingSettings
                  .onPunctuationSeconds
              : 0,
            onNumberSeconds: newBot?.startSpeakingPlan
              ?.transcriptionEndpointingPlan?.onNumberSeconds
              ? newBot?.startSpeakingPlan?.transcriptionEndpointingPlan
                  ?.onNumberSeconds
              : isCreateNewAssistant
              ? INITIAL_FORMDATA.advanced.startSpeakingSettings.onNumberSeconds
              : 0,
            onNoPunctuationSeconds: newBot?.startSpeakingPlan
              ?.transcriptionEndpointingPlan?.onNoPunctuationSeconds
              ? newBot?.startSpeakingPlan?.transcriptionEndpointingPlan
                  ?.onNoPunctuationSeconds
              : isCreateNewAssistant
              ? INITIAL_FORMDATA.advanced.startSpeakingSettings
                  .onNoPunctuationSeconds
              : 0,
            smartEndpoints: newBot?.startSpeakingPlan?.smartEndpointingEnabled
              ? newBot?.startSpeakingPlan?.smartEndpointingEnabled
              : isCreateNewAssistant
              ? INITIAL_FORMDATA.advanced.startSpeakingSettings.smartEndpoints
              : false,
          },
          endSpeakingSettings: {
            noOfWords:
              newBot?.stopSpeakingPlan?.numWords ||
              INITIAL_FORMDATA.advanced.endSpeakingSettings.noOfWords,
            voiceSeconds: newBot?.stopSpeakingPlan?.voiceSeconds
              ? newBot?.stopSpeakingPlan?.voiceSeconds
              : isCreateNewAssistant
              ? INITIAL_FORMDATA.advanced.endSpeakingSettings.voiceSeconds
              : 0,
            backOffSeconds: newBot?.stopSpeakingPlan?.backoffSeconds
              ? newBot?.stopSpeakingPlan?.backoffSeconds
              : isCreateNewAssistant
              ? INITIAL_FORMDATA.advanced.endSpeakingSettings.backOffSeconds
              : 0,
          },
          callTimeoutSettings: {
            silentTimeout: newBot?.silenceTimeoutSeconds
              ? newBot?.silenceTimeoutSeconds
              : isCreateNewAssistant
              ? INITIAL_FORMDATA.advanced.callTimeoutSettings.silentTimeout
              : 0,
            maximumDuration: newBot?.maxDurationSeconds
              ? newBot?.maxDurationSeconds
              : isCreateNewAssistant
              ? INITIAL_FORMDATA.advanced.callTimeoutSettings.maximumDuration
              : 0,
          },
          functions: {
            enableEndCallFunctions:
              newBot?.endCallFunctionEnabled ||
              INITIAL_FORMDATA.advanced.functions.enableEndCallFunctions,
            dialKeypad:
              newBot?.dialKeypadFunctionEnabled ||
              INITIAL_FORMDATA.advanced.functions.dialKeypad,
            countryCallingCode: advancedCountryCode,
            phoneNumber: newBot?.forwardingPhoneNumber
              ? newBot?.forwardingPhoneNumber?.replace(advancedCountryCode, "")
              : INITIAL_FORMDATA.advanced.functions.phoneNumber,
            toolIds: Array.isArray(newBot?.model?.toolIds)
              ? newBot?.model?.toolIds
              : INITIAL_FORMDATA.advanced?.functions?.toolIds,
          },
        },
        phoneNumber: {
          ...INITIAL_FORMDATA.phoneNumber,
          isPhoneNumberDefault:
            newBot?.phoneNumber?.isNumberDefaultAssistant ??
            INITIAL_FORMDATA.phoneNumber.isPhoneNumberDefault,
          fallbackDestinationCountryCode: fallBackCountryCode,
          fallbackDestinationPhoneNumber: newBot?.phoneNumber
            ?.fallbackDestination?.number
            ? newBot?.phoneNumber?.fallbackDestination?.number?.replace(
                fallBackCountryCode,
                ""
              )
            : INITIAL_FORMDATA.phoneNumber.fallbackDestinationPhoneNumber,
          inboundPhoneNumber:
            newBot?.phoneNumber?.name ??
            INITIAL_FORMDATA.phoneNumber?.inboundPhoneNumber,
          inboundPhoneNumberPrompt:
            newBot?.analysisPlan?.structuredDataPrompt ??
            INITIAL_FORMDATA.phoneNumber.inboundPhoneNumberPrompt,
        },
        analysisPlan: newBot?.analysisPlan,
      });
    } catch (error) {}
  };

  const changeSelection = (newBot) => {
    setHasChanged(false);
    selectedTab(1);
    getBotdetails(newBot.id);
    setData(newBot);
  };

  const handleEmotionChange = (e) => {
    setHasChanged(true);
    dispatch(setUnsavedChanges(true));
    setFormData((prevData) => ({
      ...prevData,
      emotionRecognitionEnabled: !prevData.emotionRecognitionEnabled,
    }));
  };

  const handleSliderChange = (e) => {
    setHasChanged(true);
    dispatch(setUnsavedChanges(true));
    setFormData((prevData) => ({ ...prevData, speed: e.target.value }));
  };

  const onSubmitAssistantBackground = async () => {
    if (!selectedBackground) return;
    let formData2 = new FormData();
    formData2.append("webScreen", selectedBackground);
    const result = await dispatch(
      addAssistantBackground({
        assistantId: selectedBot?.id,
        imageData: formData2,
      })
    );
    if (
      addAssistantBackground.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
    } else {
      setIsLoading(false);
      setErrorMessage(result?.payload?.error?.message);
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
      throw result?.payload?.error?.message;
    }
  };

  const hadleSubmit = async () => {
    dispatch(setUnsavedChanges(false));
    setIsLoading(true);

    const structuredDataPlan = {
      enabled: true,
      schema: {
        type: "object",
        properties: {
          name: {
            type: "string",
            description:
              "The full name of the user, including first and last name, if available then okay if noy N/A will come",
          },
          email: {
            type: "string",
            description:
              "The user's email address in a valid format, if available then okay if noy N/A will come",
          },
          phoneNumber: {
            type: "string",
            description:
              "The user's phone number in a valid format including country code, if available then okay if noy N/A will come",
          },
        },
        required: ["name", "email"],
      },
    };

    const body = {
      assistantType:
        formData?.setup?.assistantType || INITIAL_FORMDATA.setup.assistantType,
      customerId: location.state?.from != "edit" ? undefined : customerId,
      avatar: selectedBot?.avatar ?? undefined,
      backgroundDenoisingEnabled:
        formData?.advanced?.callSettings?.backgroundDenoising || false,
      backchannelingEnabled:
        formData?.advanced?.callSettings?.backchanneling || false,
      maxDurationSeconds:
        Number(formData?.advanced?.callTimeoutSettings?.maximumDuration) || 0,
      silenceTimeoutSeconds: Number(
        formData?.advanced?.callTimeoutSettings?.silentTimeout
      ),
      backgroundSound: formData.voice.backgroundSound
        ? formData.voice.backgroundSound
        : "off",
      endCallMessage: formData.advanced.callSettings.endMailMessage || "",
      voicemailMessage: formData.advanced.callSettings.voiceMailMessage || "",
      dialKeypadFunctionEnabled: formData.advanced.functions.dialKeypad,
      endCallFunctionEnabled:
        formData.advanced.functions.enableEndCallFunctions,
      forwardingPhoneNumber:
        formData.advanced.functions.countryCallingCode &&
        formData.advanced.functions.phoneNumber
          ? formData.advanced.functions.countryCallingCode +
            formData.advanced.functions.phoneNumber.replace(/\D/g, "")
          : undefined,
      firstMessage: formData?.setup?.firstMessage,
      email: {
        subject: formData.email.subject,
        description: formData.email.description,
      },
      transcriber: {
        model: formData.voice.transcriberModel,
        provider: formData.voice.transcriberProvider,
        language: formData?.voice.language,
      },
      hipaaEnabled: formData?.advanced?.callSettings?.hipaaCompliance || false,
      recordingEnabled:
        formData?.advanced?.callSettings?.audioRecording || false,
      voice: {
        speed: formData?.voice?.speed
          ? Number(formData?.voice?.speed)
          : undefined,
        voiceId: formData?.voice?.voice,
        provider: formData.voice.provider,
        fillerInjectionEnabled:
          formData?.advanced?.callSettings?.filterInjection || false,
      },
      model: {
        knowledgeBaseId: selectedKnowledgeBaseDocument
          ? selectedKnowledgeBaseDocument
          : undefined,
        emotionRecognitionEnabled:
          formData.voice.emotionRecognitionEnabled || false,
        provider: formData.voice.assistantProvider,
        model: formData.voice.assistantModel,
        toolIds: formData?.advanced?.functions?.toolIds,
        messages: [
          {
            role: "system",
            content: formData.setup.systemPrompt,
          },
        ],
      },
      artifactPlan: {
        videoRecordingEnabled:
          formData?.advanced?.callSettings?.videoRecording || false,
      },
      messagePlan: {
        idleMessages: formData?.advanced?.callSettings?.idleMessage,
        idleMessageMaxSpokenCount: Number(
          formData?.advanced?.callSettings?.maxIdleMessage
        ),
        idleTimeoutSeconds: Number(
          formData?.advanced?.callSettings?.idleTimeout
        ),
      },
      startSpeakingPlan: {
        waitSeconds: Number(
          formData?.advanced?.startSpeakingSettings.waitSeconds
        ),
        smartEndpointingEnabled:
          formData?.advanced?.startSpeakingSettings?.smartEndpoints,
        transcriptionEndpointingPlan: {
          onPunctuationSeconds: Number(
            formData?.advanced?.startSpeakingSettings.onPunctuationSeconds
          ),
          onNumberSeconds: Number(
            formData?.advanced?.startSpeakingSettings.onNumberSeconds
          ),
          onNoPunctuationSeconds: Number(
            formData?.advanced?.startSpeakingSettings.onNoPunctuationSeconds
          ),
        },
      },
      stopSpeakingPlan: {
        numWords: Number(formData?.advanced?.endSpeakingSettings.noOfWords),
        voiceSeconds: Number(
          formData?.advanced?.endSpeakingSettings.voiceSeconds
        ),
        backoffSeconds: Number(
          formData?.advanced?.endSpeakingSettings.backOffSeconds
        ),
      },
      form: {
        instructions: formData?.form?.instructions,
        submitAction: formData?.form?.formActions,
        fields: formData?.form?.fields?.length
          ? formData?.form?.fields?.map((field, index) => ({
              ...field,
              name: field?.label ?? field?.name,
              order: index,
              id: field?.isFromAdd ? undefined : field?.id,
            }))
          : ALL_FORM_FIELDS,
      },
      widgetConfig: {
        ...formData?.widget,
        forwardingPhoneNumber: formData?.widget?.forwardingPhoneNumber?.replace(
          /\D/g,
          ""
        ),
      },
      emailAddress: formData.setup.emailAddress
        ? formData.setup.emailAddress
        : [],
      sendSummary: formData.setup.sendSummary || false,
      sendSummaryToContact: formData.setup.sendSummaryToContact || false,
      pdfSummary: formData.setup.pdfSummary || false,
      sendTranscript: formData.setup.sendTranscript || false,
      sendRecording: formData.setup.sendRecording || false,
      endCallPhrases: formData.voice.endCallPhrases
        ? [formData.voice.endCallPhrases]
        : [],
      phoneNumber: {
        name: formData.phoneNumber.inboundPhoneNumber,
        assistantId: selectedBot?.id ?? null,
        isNumberDefaultAssistant: formData.phoneNumber.isPhoneNumberDefault,
        fallbackDestination: {
          type: "number",
          number: formData.phoneNumber.fallbackDestinationPhoneNumber
            ? `${
                formData.phoneNumber.fallbackDestinationCountryCode
              }${formData.phoneNumber.fallbackDestinationPhoneNumber?.replace(
                /\D/g,
                ""
              )}`
            : null,
        },
      },
      analysisPlan:
        formData?.analysisPlan && typeof formData?.analysisPlan == "object"
          ? {
              ...formData?.analysisPlan,
              summaryPrompt: formData.setup.summaryInstructions
                ? formData.setup.summaryInstructions
                : undefined,
            }
          : {
              structuredDataPrompt:
                formData.phoneNumber.inboundPhoneNumberPrompt,
              structuredDataPlan: structuredDataPlan,
              summaryPrompt: formData.setup.summaryInstructions
                ? formData.setup.summaryInstructions
                : undefined,
            },
    };
    if (location.state?.from != "edit") {
      const blob = await getFile(1);
      let formData2 = new FormData();
      if (blob && blob.file) {
        formData2.append("file", blob?.file, blob?.file?.name); // Append Blob to FormData
      }
      if (selectedBackground) {
        formData2.append("webScreen", selectedBackground);
      }
      if (customerId) {
        formData2.append("customerId", customerId);
      }
      formData2.append("name", JSON.stringify(location?.state?.name));
      formData2.append("body", JSON.stringify(body));
      // formData2.append("firstMessage", JSON.stringify(formData.firstMessage));
      // setIsLoading(false)
      // return ;
      const result = await dispatch(CreateAssistant(formData2));
      if (
        CreateAssistant.fulfilled.match(result) &&
        result?.payload?.success === true
      ) {
        await deleteById(1);
        setIsLoading(false);
        setSuccessMessage("Assistant Created Successfully!");
        setSuccessModel(true);
        setTimeout(() => {
          setSuccessModel(false);
          if (customerId) {
            navigate(`/assistants/${customerId}`, {
              state: {
                planType: location?.state?.planType,
                customerName: location?.state?.customerName,
              },
            });
          } else {
            navigate("/assistants");
          }
        }, 1500);
      } else {
        //TODO: error popup here
        setIsLoading(false);
        setErrorMessage(result?.payload?.error?.message);
        setErrorModel(true);
        setTimeout(() => {
          setErrorModel(false);
        }, 4000);
      }
    } else {
      try {
        await onSubmitAssistantBackground();
        const result = await dispatch(
          UpdateAssistant({ id: selectedBot?.id, body })
        );
        if (
          UpdateAssistant.fulfilled.match(result) &&
          result?.payload?.success === true
        ) {
          setIsLoading(false);
          setSuccessMessage("Assistant Updated Successfully!");
          setSuccessModel(true);
          dispatch(getAssistantsCount());
          await dispatch(getAssistantList({ text: "", customerId }));
          setTimeout(() => {
            setSuccessModel(false);
            setHasChanged(false);
            dispatch(setUnsavedChanges(false));
            getBotdetails(selectedBot?.id);
            selectedTab(1);
          }, 1500);
        } else {
          //TODO: error popup here
          setIsLoading(false);
          setErrorMessage(result?.payload?.error?.message);
          setErrorModel(true);
          setTimeout(() => {
            setErrorModel(false);
          }, 1500);
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const onSuccessAssistant = () => {
    setEditAssistantVisible(false);
    setSuccessMessage("Assistant Updated Successfully!");
    setSuccessModel(true);
    setTimeout(() => {
      setSuccessModel(false);
      getBotdetails(selectedBot?.id);
    }, 1500);
  };

  const onClickNext = () => {
    hadleSubmit();
  };

  const handleCloseShareForm = () => {
    setShareFormLinkModal({
      visible: false,
      url: "",
    });
  };

  const shareForm = async () => {
    setIsLoading(true);
    const result = await dispatch(shareAssistantForm(selectedBot?.id));
    if (
      shareAssistantForm.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      dispatch(setUnsavedChanges(false));
      setShareFormLinkModal({
        visible: true,
        url: result?.payload?.data?.url,
      });
    } else {
      setIsLoading(false);
      setErrorMessage(result?.payload?.error?.message);
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    }
  };

  return (
    <div className="page__body">
      {shareFormLinkModal?.visible ? (
        <ShareLinkModal
          url={shareFormLinkModal.url}
          onClose={handleCloseShareForm}
        />
      ) : null}
      {editAssistantVisible ? (
        <EditAssistantModal
          selectedBot={selectedBot}
          closePopup={() => setEditAssistantVisible(false)}
          onSuccess={onSuccessAssistant}
        />
      ) : null}
      {buyAdditionalAssistantModal?.visible ? (
        <BuyAdditionalAssistantModal
          onClose={handleCloseBuyAdditionalAssistant}
          type={buyAdditionalAssistantModal.type}
          maxAssistant={buyAdditionalAssistantModal.maxAssistant}
          assistantAmount={buyAdditionalAssistantModal.assistantAmount}
        />
      ) : null}
      {errorModel ? <ErrorModel message={errorMessage} /> : ""}
      {successModel ? <SuccessModel message={successMessage} /> : ""}
      {isLoading ? <Loader /> : ""}
      {confirmModel ? (
        <ConfirmModel
          onAccept={onDelete}
          onReject={() => {
            setCOnfirmModel(false);
          }}
          title="Delete Assistant!"
          message="Are you sure you want to Delete the Assistant?"
        />
      ) : (
        ""
      )}
      {hasChangedModel ? (
        <ConfirmModel
          onAccept={() => {
            dispatch(setUnsavedChanges(false));
            if (customerId) {
              navigate(`/assistants/${customerId}`, {
                state: {
                  planType: location?.state?.planType,
                  customerName: location?.state?.customerName,
                },
              });
            } else {
              navigate("/assistants");
            }
          }}
          yes={"Yes"}
          no={"No"}
          onReject={() => {
            setHasChangedModel(false);
          }}
          title="Update Changes!"
          message="Changes made will not be saved. Are you sure you want to leave the page?"
        />
      ) : null}

      <div className="createAssistantMain h_100">
        <AssistantsListSidebar
          changeSelection={changeSelection}
          onClickCreateAssistant={()=> onClickCreateAssistant()}
        />
        <div className="createAssistantMain__col h_100">
          <div className="createAssistantMain__card">
            <div className="createAssistantHeader">
              <div className="createAssistantHeader__info">
                <div style={{ display: "flex", alignItems: "center" }}>
                  {!selectedBot?.avatar ? (
                    <div className="icon icon--bg1">
                      <DefaultChatBot />
                    </div>
                  ) : (
                    <img className="icon icon--bg1" src={selectedBot?.avatar} />
                  )}
                  <div style={{ marginLeft: "16px" }}>
                    <h1 className="title title--h3">
                      {location.state?.from != "edit"
                        ? location?.state?.name
                        : selectedBot?.name}{" "}
                      {selectedBot?.id ? (
                        <button
                          className="backBtn"
                          onClick={() => setEditAssistantVisible(true)}
                        >
                          <EditBlueIcon />
                          Edit
                        </button>
                      ) : null}
                    </h1>
                    {location.state?.from == "edit" ? (
                      <CopyBox text={selectedBot?.id} />
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="btn__group">
                {!isMetaAssistant ? (
                  <button
                    disabled={!selectedBot?.id}
                    className="btn btn__danger btn__outlined"
                    onClick={onDeleteClicked}
                  >
                    <SolidTrashIcon />
                    Delete
                  </button>
                ) : null}
                {isCallActive ? (
                  <button className="btn btn__primary" onClick={toggleMute}>
                    {isMuted ? (
                      <MuteIcon width="15" height="22" />
                    ) : (
                      <UnMuteIcon width="15" height="22" />
                    )}
                  </button>
                ) : null}
                {!isCallActive ? (
                  <button
                    className="btn btn__primary"
                    onClick={startCall}
                    disabled={!selectedBot?.id}
                  >
                    <CallIcon />
                    Test Assistant
                  </button>
                ) : (
                  <button className="btn btn__primary" onClick={endCall}>
                    <EndCallIcon width="22" height="22" />
                    End Call
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="createAssistantMain__card createAssistantMain__card--second">
            <div className="createAssistantHeader">
              <div className="createAssistantHeader__info">
                <div className="tabsWrap tabsWrap--second">
                  <ul className="tabs">
                    <li
                      className={
                        tabs === 1
                          ? "tabs__link tabs__link--selected"
                          : "tabs__link"
                      }
                      onClick={() => selectedTab(1)}
                    >
                      Set Up
                    </li>
                    {!isMetaAssistant ? (
                      <li
                        className={
                          tabs === 2
                            ? "tabs__link tabs__link--selected"
                            : "tabs__link"
                        }
                        onClick={() => selectedTab(2)}
                      >
                        Form
                      </li>
                    ) : null}
                    {userPlanFeatures?.EMAIL && !isMetaAssistant ? (
                      <li
                        className={
                          tabs === 3
                            ? "tabs__link tabs__link--selected"
                            : "tabs__link"
                        }
                        onClick={() => selectedTab(3)}
                      >
                        Email
                      </li>
                    ) : null}
                    <li
                      className={
                        tabs === 4
                          ? "tabs__link tabs__link--selected"
                          : "tabs__link"
                      }
                      onClick={() => selectedTab(4)}
                    >
                      Voice
                    </li>
                    {userPlanFeatures?.ASSISTANT_WIDGET_FOR_WEB &&
                    !isMetaAssistant ? (
                      <li
                        className={
                          tabs === 5
                            ? "tabs__link tabs__link--selected"
                            : "tabs__link"
                        }
                        onClick={() => selectedTab(5)}
                      >
                        Website Widget
                      </li>
                    ) : null}
                    <li
                      className={
                        tabs === 6
                          ? "tabs__link tabs__link--selected"
                          : "tabs__link"
                      }
                      onClick={() => selectedTab(6)}
                    >
                      Advanced
                    </li>
                    {userPlanFeatures?.IN_BOUND_CALL &&
                    selectedBot?.id &&
                    !isMetaAssistant ? (
                      <li
                        className={
                          tabs === 7
                            ? "tabs__link tabs__link--selected"
                            : "tabs__link"
                        }
                        onClick={() => selectedTab(7)}
                      >
                        Phone Number
                      </li>
                    ) : null}
                  </ul>
                </div>
              </div>
              <div className="btn__group">
                {selectedBot?.id && !isMetaAssistant ? (
                  <button
                    className="btn btn__white"
                    onClick={() => shareForm()}
                  >
                    <ShareIcon />
                    Share Form
                  </button>
                ) : null}
                <button
                  className="btn btn__white"
                  onClick={() => {
                    if (hasChanged) {
                      setHasChangedModel(true);
                    } else {
                      dispatch(setUnsavedChanges(false));
                      if (customerId) {
                        navigate(`/assistants/${customerId}`, {
                          state: {
                            planType: location?.state?.planType,
                            customerName: location?.state?.customerName,
                          },
                        });
                      } else {
                        navigate("/assistants");
                      }
                    }
                  }}
                >
                  Cancel
                </button>
                <button
                  className="btn btn__primary"
                  disabled={
                    formData.setup.firstMessage === "" ||
                    !formData.setup.systemPrompt ||
                    (!isMetaAssistant && !formData.form.instructions) ||
                    // (formData.type != "" && formData.functionName === "") ||
                    hasFormError
                  }
                  onClick={onClickNext}
                >
                  Publish
                </button>
              </div>
            </div>
            {}
            <div className="createAssistantBody">
              <div className="tabsContent" ref={divRef}>
                <SetUpTab
                  isTabSelected={tabs === 1}
                  formData={formData?.setup}
                  setFormData={setFormData}
                  formError={formError}
                  setFormError={setFormError}
                  assistantId={selectedBot?.id}
                  selectedKnowledgeBaseDocument={selectedKnowledgeBaseDocument}
                  setSelectedKnowledgeBaseDocument={(doc) => {
                    setHasChanged(true);
                    dispatch(setUnsavedChanges(true));
                    setSelectedKnowledgeBaseDocument(doc);
                  }}
                  getDocumentsList={getDocumentsList}
                  handleChange={handleChangeSetupStep}
                  userPlanFeatures={userPlanFeatures}
                  selectedBackground={selectedBackground}
                  setSelectedBackground={setSelectedBackground}
                  setHasChanged={setHasChanged}
                  showErrorMessage={showErrorMessage}
                  isMetaAssistant={isMetaAssistant}
                />

                <FormTab
                  formData={formData}
                  setFormData={setFormData}
                  formError={formError}
                  setFormError={setFormError}
                  isTabSelected={tabs === 2}
                  userPlanFeatures={userPlanFeatures}
                  setIsLoading={setIsLoading}
                  showErrorMessage={showErrorMessage}
                  assistantId={selectedBot?.id}
                />

                <EmailTab
                  isTabSelected={tabs === 3}
                  formData={formData?.email}
                  formError={formError}
                  handleChange={handleChangeEmailStep}
                  userPlanFeatures={userPlanFeatures}
                  setFormData={setFormData}
                  assistantId={selectedBot?.id}
                  isMetaAssistant={isMetaAssistant}
                />

                <VoiceTab
                  isTabSelected={tabs === 4}
                  formData={formData?.voice}
                  formError={formError}
                  handleEmotionChange={handleEmotionChange}
                  handleChange={handleChangeVoiceStep}
                  handleSliderChange={handleSliderChange}
                  selectedBot={selectedBot}
                  setFormData={setFormData}
                  userPlanFeatures={userPlanFeatures}
                />

                <WebsiteWidgetTab
                  isTabSelected={tabs === 5}
                  widgetData={formData.widget}
                  formError={formError}
                  setFormError={setFormError}
                  handleChange={handleChangeWebsiteWidget}
                  assistantId={selectedBot?.id}
                  setIsLoading={setIsLoading}
                  showSuccessMessage={showSuccessMessage}
                  showErrorMessage={showErrorMessage}
                  userPlanFeatures={userPlanFeatures}
                />

                <AdvancedTab
                  isTabSelected={tabs === 6}
                  formData={formData?.advanced}
                  formError={formError}
                  setFormError={setFormError}
                  setFormData={setFormData}
                  setHasChanged={setHasChanged}
                  userPlanFeatures={userPlanFeatures}
                  isMetaAssistant={isMetaAssistant}
                />

                <PhoneNumberTab
                  isTabSelected={tabs === 7}
                  formData={formData?.phoneNumber}
                  formError={formError}
                  setFormError={setFormError}
                  setFormData={setFormData}
                  setHasChanged={setHasChanged}
                  userPlanFeatures={userPlanFeatures}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
